import { buildGiftCardItem, buildItemsFromOrderInfo, firstCouponName, orderValue, withoutEmptyValues, } from "../Shared/analytics/ecommerce";
export const buildOrderPurchase = (orderInfo, currency, itemBrand) => withoutEmptyValues({
    transaction_id: orderInfo.order_number || String(orderInfo.OrderId),
    currency,
    value: orderValue(orderInfo),
    purchase_type: orderInfo.IsSubscription ? "subscription" : "one_time",
    tax: orderInfo.tax,
    shipping: orderInfo.shipping,
    coupon: firstCouponName(orderInfo),
    shipping_tier: orderInfo.IsPickup ? "Pickup" : "Delivery",
    items: buildItemsFromOrderInfo(orderInfo, itemBrand),
});
export const buildGiftCardPurchase = (giftCard, currency, itemBrand) => withoutEmptyValues({
    transaction_id: giftCard.orderNumber,
    currency,
    value: giftCard.paymentAmount,
    purchase_type: "one_time",
    items: [buildGiftCardItem(giftCard.paymentAmount, itemBrand)],
});
